import i18nextInit from 'i18n'
import * as msgTypes from 'models/iFrame/msgTypes'
import { getPathRegion, getBaseUrl } from 'models/location/selectors'
import { isProd, getTestingEnv } from 'utils/environment'
import { APP_ENV_PROD, APP_ENV_TESTING } from 'models/tracking/constants'
import mwEn from '../../../locales/en/mw.json'
import mwNl from '../../../locales/nl-nl/mw.json'
import commonEn from '../../../locales/en/common.json'
import commonNl from '../../../locales/nl-nl/common.json'
import { DEV_IDS_BY_REGION, PROD_IDS_BY_REGION, DEFAULT_CATALOG, DEFAULT_SHOWROOM } from './idsByRegion'

const resources = {
    en: {
        mw: mwEn,
        common: commonEn,
    },
    'nl-nl': {
        mw: mwNl,
        common: commonNl,
    },
}
const i18nOptions = {
    resources,
    ns: 'mw',
    defaultNS: 'mw',
}

const onI18nError = () => {
    // eslint-disable-next-line no-console
    console.log('Error in i18n init for magic window')
}

i18nextInit(onI18nError, i18nOptions).then((t) => {
    const geoHeaderNode = document.querySelector('#GeomagicalWindow .geoHeader')
    if (geoHeaderNode) {
        geoHeaderNode.innerHTML = t('magicWindow.header')
    }
    const geoSubheaderNode = document.querySelector('#GeomagicalWindow .geoSubheader')
    if (geoSubheaderNode) {
        geoSubheaderNode.innerHTML = t('magicWindow.subheader')
    }
    const geoHeaderButtonNode = document.querySelector('#GeomagicalWindow .geoHeaderButton')
    if (geoHeaderButtonNode) {
        geoHeaderButtonNode.innerHTML = t('magicWindow.open magic window')
    }
    const geoCtaButtonNode = document.querySelector('#GeomagicalWindow .geoCtaButton')
    if (geoCtaButtonNode) {
        geoCtaButtonNode.innerHTML = t('magicWindow.explore this room in 3D')
    }
    const geoCardHeaderNode = document.querySelector('#GeomagicalWindowCard .geoCardHeader')
    if (geoCardHeaderNode) {
        geoCardHeaderNode.innerHTML = t('magicWindow.furnish this space in 3D')
    }
    const geoCardSubheaderNode = document.querySelector('#GeomagicalWindowCard .geoCardSubheader')
    if (geoCardSubheaderNode) {
        geoCardSubheaderNode.innerHTML = t('magicWindow.explore your home design')
    }
    const geoCardCtaButtonNode = document.querySelector('#GeomagicalWindowCard .geoHeaderButton')
    if (geoCardCtaButtonNode) {
        geoCardCtaButtonNode.innerHTML = t('magicWindow.try it now')
    }

    const geoTwoByTwoHeaderNode = document.querySelector('#GeomagicalWindowTwoByTwoDining .geoTwoByTwoHeader')
    if (geoTwoByTwoHeaderNode) {
        geoTwoByTwoHeaderNode.innerHTML = t('magicWindow.dining room furniture to mix-and-match')
    }
    const geoTwoByTwoSubheaderNode = document.querySelector('#GeomagicalWindowTwoByTwoDining .geoTwoByTwoSubheader')
    if (geoTwoByTwoSubheaderNode) {
        geoTwoByTwoSubheaderNode.innerHTML = t('magicWindow.dining room subheader')
    }
    const geoTwoByTwoHeaderButtonNode = document.querySelector('#GeomagicalWindowTwoByTwoDining .geoHeaderButton')
    if (geoTwoByTwoHeaderButtonNode) {
        geoTwoByTwoHeaderButtonNode.innerHTML = t('magicWindow.start your 3D design')
    }
    const geoTwoByTwoCtaButtonNodes = document.querySelectorAll(
        '#GeomagicalWindowTwoByTwoDining .geoCtaButton .geoCtaButtonText',
    )
    if (geoTwoByTwoCtaButtonNodes) {
        geoTwoByTwoCtaButtonNodes.forEach(
            // eslint-disable-next-line no-param-reassign
            (ctaButtonnode) => (ctaButtonnode.innerHTML = t('magicWindow.explore this room in 3D')),
        )
    }
})

const REGION = getPathRegion()

let geoCompositionId = isProd
    ? PROD_IDS_BY_REGION[REGION][DEFAULT_SHOWROOM].compId
    : DEV_IDS_BY_REGION[REGION][DEFAULT_SHOWROOM].compId
let geoSceneId = isProd
    ? PROD_IDS_BY_REGION[REGION][DEFAULT_SHOWROOM].sceneId
    : DEV_IDS_BY_REGION[REGION][DEFAULT_SHOWROOM].sceneId

const isTestingEnv = getTestingEnv()

function trackGoogleAnalytics(action, label, options = {}) {
    if (window.sendEvent) {
        window.sendEvent({
            ...options,
            AppEnvironment: isTestingEnv ? APP_ENV_TESTING : APP_ENV_PROD,
            event_category: 'magic_window',
            event_action: action,
            event_label: label,
        })
    }
}

function makeModalWidth() {
    const iframeElement = document.getElementById('GeomagicalIFrame')
    iframeElement.classList.remove('fullWidth')
    iframeElement.classList.add('modalWidth')
}

function makeFullWidth() {
    const iframeElement = document.getElementById('GeomagicalIFrame')
    iframeElement.classList.add('fullWidth')
    iframeElement.classList.remove('modalWidth')
}

function closeMagicWindow() {
    document.getElementById('GeomagicalModal').style.display = 'none'
    const iframeElement = document.getElementById('GeomagicalIFrame')
    iframeElement.classList.remove('modalWidth')
    iframeElement.classList.remove('fullWidth')

    const scrollY = document.body.style.top
    document.body.style.position = ''
    document.body.style.top = ''
    window.scrollTo(0, parseInt(scrollY || '0', 10) * -1)

    trackGoogleAnalytics('close', geoCompositionId)
}

function doGetTokens(sourceWindow) {
    if (window.ikea && window.ikea.authentication) {
        window.ikea.authentication.getTokens((error, tokens) =>
            sourceWindow.postMessage(
                {
                    type: msgTypes.GET_TOKENS_RESPONSE,
                    tokens,
                    error,
                    isDev: window.location.hostname.includes('.cte.'),
                },
                SUGARCUBE_ORIGIN,
            ),
        )
    }
}

function onMessage(message) {
    const { data = {}, origin, source } = message
    if (origin !== SUGARCUBE_ORIGIN) {
        return
    }
    const { type, action, label } = data
    switch (type) {
        case msgTypes.MAGIC_WINDOW_CLOSE: {
            closeMagicWindow()
            break
        }
        case msgTypes.MAGIC_WINDOW_LOADED: {
            trackGoogleAnalytics('load_complete', geoCompositionId)
            makeModalWidth()
            doGetTokens(message.source)
            break
        }
        case msgTypes.MAGIC_WINDOW_MODAL_SCREEN: {
            makeModalWidth()
            break
        }
        case msgTypes.MAGIC_WINDOW_FULL_SCREEN: {
            makeFullWidth()
            break
        }
        case msgTypes.MAGIC_WINDOW_GA_TRACKING: {
            trackGoogleAnalytics(action, label)
            break
        }
        case msgTypes.GET_TOKENS: {
            doGetTokens(source)
            break
        }
        default: {
            break
        }
    }
}

function openMagicWindow(event) {
    const { target } = event
    const showroom = target.closest('.geoStartMagicWindow').getAttribute('data-showroom')

    const prodCompositionId = showroom
        ? PROD_IDS_BY_REGION[REGION][showroom].compId
        : PROD_IDS_BY_REGION[REGION][DEFAULT_SHOWROOM].compId

    const prodSceneId = showroom
        ? PROD_IDS_BY_REGION[REGION][showroom].sceneId
        : PROD_IDS_BY_REGION[REGION][DEFAULT_SHOWROOM].sceneId

    const devCompositionId = showroom
        ? DEV_IDS_BY_REGION[REGION][showroom].compId
        : DEV_IDS_BY_REGION[REGION][DEFAULT_SHOWROOM].compId

    const devSceneId = showroom
        ? DEV_IDS_BY_REGION[REGION][showroom].sceneId
        : DEV_IDS_BY_REGION[REGION][DEFAULT_SHOWROOM].sceneId

    const devSubCatalog = showroom
        ? DEV_IDS_BY_REGION[REGION][showroom].subCatalog
        : DEV_IDS_BY_REGION[REGION][DEFAULT_SHOWROOM].subCatalog || DEFAULT_CATALOG
    const prodSubCatalog = showroom
        ? PROD_IDS_BY_REGION[REGION][showroom].subCatalog
        : PROD_IDS_BY_REGION[REGION][DEFAULT_SHOWROOM].subCatalog || DEFAULT_CATALOG

    geoCompositionId = isProd ? prodCompositionId : devCompositionId
    geoSceneId = isProd ? prodSceneId : devSceneId
    const subCatalog = isProd ? prodSubCatalog : devSubCatalog

    const magicWindowModal = document.getElementById('GeomagicalModal')
    let magicWindowIframe = document.getElementById('GeomagicalIFrame')
    if (!magicWindowIframe) {
        magicWindowIframe = document.createElement('iframe')
        magicWindowIframe.id = 'GeomagicalIFrame'
    }
    window.addEventListener('message', onMessage)
    const canvasWidth = window.innerWidth

    const optionalTestingUrlParam = isTestingEnv ? '&testing=true' : ''
    // eslint-disable-next-line max-len
    const urlParams = `subCatalog=${subCatalog}&canvasWidth=${canvasWidth}${optionalTestingUrlParam}#${geoCompositionId}/${geoSceneId}`

    let source = `${getBaseUrl()}/magicWindow?${urlParams}`
    if (window.location.hostname === 'localhost') {
        source = `//localhost:1080/magicWindow.html?${urlParams}`
    }
    magicWindowIframe.src = source

    magicWindowModal.appendChild(magicWindowIframe)
    magicWindowModal.style.display = 'flex'

    document.body.style.top = `-${window.scrollY}px`
    document.body.style.position = 'fixed'

    trackGoogleAnalytics('open', geoCompositionId)
}

const startButtons = document.querySelectorAll('.geoStartMagicWindow')
for (let i = 0, max = startButtons.length; i < max; i += 1) {
    startButtons[i].onclick = openMagicWindow
}

// To catch the browser close event
window.addEventListener('beforeunload', (event) => {
    const magicWindowModal = document.getElementById('GeomagicalModal')
    const isMagicWindowOpen = magicWindowModal.style.display === 'flex'

    if (isMagicWindowOpen) {
        // Cancel the event as stated by the standard.
        event.preventDefault()

        // Older browsers supported custom message
        // eslint-disable-next-line no-param-reassign
        event.returnValue = ''

        trackGoogleAnalytics('close', geoCompositionId, { transport_type: 'beacon' })
    }
})
